import { render } from "./ListClients.vue?vue&type=template&id=22909cd2"
import script from "./ListClients.vue?vue&type=script&lang=js"
export * from "./ListClients.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-clients\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__